import { toCamelCase, parse } from 'tools/string'
import { DEV } from 'env'

export const toJSON = (cookie) => {
  const output = {}
  cookie
    .split(/\s*;\s*/)
    .forEach((_) => {
      const pair = _.split(/\s*=\s*/)
      output[toCamelCase(pair[0])] = parse(pair.splice(1).join('='))
    })
  return output
}

export const arrayToJSON = (lines) => (lines || []).reduce((acc, line) => Object.assign({}, acc, toJSON(line)), {})

// WORKAROUND: non-HTTPS environment (local, staging, etc.) cookie would not work due to secure flag from OMS
export const stripSecureFlag = (cookies) => DEV ? (cookies || []).map(c => c.replace(/Secure;?/, '')) : cookies

// https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
export const getCookie = (cookie, key) => (cookie || '').replace(new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1')
